import React from "react";
import { ShieldCheck, Lock, CreditCard } from "lucide-react";

/**
 * Compact row of trust/security badges — safe to drop anywhere.
 * Variant 'light' = for use on the purple/red band sections
 * Variant 'dark'  = for use on black sections
 */
export default function TrustBadges({ variant = "dark", className = "" }) {
  const badges = [
    { icon: ShieldCheck, label: "SSL SECURED" },
    { icon: Lock, label: "PRIVATE & CONFIDENTIAL" },
    { icon: CreditCard, label: "SECURE PAYMENTS BY SQUARE" },
  ];
  const bg = variant === "light" ? "bg-white/5" : "bg-white/8";
  const bd = variant === "light" ? "border-white/10" : "border-white/12";

  return (
    <div className={`flex flex-wrap items-center gap-3 ${className}`}>
      {badges.map(({ icon: Icon, label }) => (
        <div
          key={label}
          className={`inline-flex items-center gap-2 px-3 py-2 rounded-lg border ${bd} ${bg}`}
        >
          <Icon size={14} className="text-emerald-400" strokeWidth={2.4} />
          <span className="text-white/85 text-[10px] tracking-[0.2em] font-heading font-semibold">
            {label}
          </span>
        </div>
      ))}
    </div>
  );
}
